import { authHeaders } from '@/utils/authToken';
import type { Badge, GamificationLogEntry, LeaderboardEntry } from '@/types';

export const gamificationService = {
  async getPoints(): Promise<{ total_points: number; history: GamificationLogEntry[] }> {
    const res = await fetch('/api/gamification/points', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async getBadges(): Promise<(Badge & { earned: boolean })[]> {
    const res = await fetch('/api/gamification/badges', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async getLeaderboard(zone?: string): Promise<LeaderboardEntry[]> {
    const params = zone ? `?zone=${zone}` : '';
    const res = await fetch(`/api/gamification/leaderboard${params}`, { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
